import Card from "../../components/UI/Card";
import React from "react";
import {NavLink} from "react-router-dom";
import Button from "../../components/UI/Button";

const NoAccess = ()=>{
    return (
        <Card title={'No Access'}>
            <div className="no_access width_full">
                <p className={'width_full mb_10'}>You do not have the required authorization.</p>
                <NavLink className="width_full" end to="/">
                    <Button text={'Go Home'} />
                </NavLink>
            </div>
        </Card>
    );
}
export default NoAccess